import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';

@Component({
    selector: 'app-shared-u-engine',
    templateUrl: './shared-u-engine.component.html',
    styleUrls: ['./shared-u-engine.component.scss'],
    standalone: false
})
export class SharedUEngineComponent extends UiEngineComponent {
  communicationService: any;
extra_form:any;
view_details:any;
cust_button= {
  "Add": [{
          "label": "Submit",
          "icon": "fa fa-check"
  }
  ]
}
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public asideBarService: AsideBarService
  ) {
    super(injector, router, route, modal)
    this.communicationService.emitSidebar({ sidebar: false });
  }


  ngOnInit() {
    this.uiInit();
    let ui_json;
    if(this.route.data['_value'].screen == "query")
    ui_json='insurance_form_detal';
    if(this.route.data['_value'].screen == "approve")
    ui_json='approved_remarks'
    if(this.route.data['_value'].screen == "answer")
  ui_json='answer_ins'
    if(this.route.data['_value'].screen == "verify")
    {
    ui_json='verify_view'
    this.cust_button = {
      "Add": [{
              "label": "button.final",
              "icon": "fa fa-check"
          },
          {
              "label": "button.reject",
              "icon": "fa fa-save"
          }
      ]
  }
    }
    this.baseService.getResourceDef(ui_json, (resouceDef) => {
      if (resouceDef) {
this.extra_form=resouceDef;

    }})
  }
  uiInit(config?) {
    if (!this.parent_id) {
      this.parent_id = 0;
    }
    this.view_details = JSON.parse(sessionStorage.getItem('currentData'))
    if (this._currentData.origArhiveConfig == undefined) {
      this.initCurrentData();
      if (config && config["archiveConfig"] != undefined) {
        this._currentData["archiveConfig"] = {};
        this._currentData["archiveConfig"]["selected"] = config["archiveConfig"];
        this._currentData["archiveConfig"]["applied"] = true;
        this._currentData.dataGridConfig = {};
        this._currentData.gridData.page_no = 0;
        this.updatePageInUrl(this._currentData.gridData.page_no, true);
      } else {
        //if its archive old filter and page number is not needed bevause we may not support the applied filters on archive data
        this._currentData.loadSavedFilter = true;
        if (this.route.snapshot.queryParams["p__no"] != undefined) {
          this._currentData.gridData.page_no = parseInt(this.route.snapshot.queryParams["p__no"])
        }
      }
      if (this.resourcename) {
        this._currentData.resource = this.resourcename;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.data.resource != undefined) {
        this._currentData.resource = this.route.snapshot.data.resource;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.paramMap.get('resource') != null) {
        this._currentData.resource = this.route.snapshot.paramMap.get('resource');
        this._currentData.json = this.route.snapshot.paramMap.get('resource');
      }
      if (this.route.snapshot.data.view != undefined && this.route.snapshot.data.view) {
        this._currentData.view = this.route.snapshot.data.view;
        this._currentData.json = this._currentData.view;
      }
    } else {
      //archive is loading
      var origArhiveConfig = JSON.parse(JSON.stringify(this._currentData.origArhiveConfig));
      this.initCurrentData();
      this._currentData.origArhiveConfig = origArhiveConfig;
      this._currentData.json = this._currentData.origArhiveConfig.resource;
    }
    this._currentData.bookmarks = undefined;
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        // this.preferenceService.getUserPreferenceConfig(this._currentData.save_key, (preferenceData) => {
        //   this._currentData.preferenceData = preferenceData;
        this._currentData.currentResource = resouceDef.resource;
        if (resouceDef.layout_type != undefined && resouceDef.layout_type) {
          this._layout = resouceDef.layout_type
        } else {
          this._layout = 'simple';
        }
        if (this._currentData.origArhiveConfig != undefined) {
          if (resouceDef.config == undefined) {
            resouceDef.config = {};
          }
          this._currentData.gridData.page_no = 0;//resetting page
          resouceDef.config.archive = this._currentData.origArhiveConfig;
          resouceDef.config.archive.isON = true;

        }
        if (this._layout == 'simple') {
          this.checkIfArchiveAvailable(resouceDef);
          this.loadInitalConfig(this._currentData.json, () => {
            if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
              var afterConfig = this.preferenceService.applyJsonConfig({ resouceDef: resouceDef }, this._currentData.uiConfigData);
              if (afterConfig.resouceDef != undefined) {
                resouceDef = afterConfig.resouceDef;
              }
            }
            this._layout_data = resouceDef;
            this.initLayoutData();
          });

        } else {
          /*Calling Same code Just 
            layoutRenderer() Have same same code */

          this.layoutRenderer(resouceDef);
        }
        //});

      }
    });
    this.getParamValueQueryString('key', (response) => {
      if (response) {
        this.arg_key = response;
      }
    });
  }
  getByQueryID(apiObj?) {
    this.loader.showSpinner();
    if (apiObj == undefined) {
      var apiObj: any = {};
      apiObj.resource = this._currentData.currentFormFields.datasource.resource != undefined ? this._currentData.currentFormFields.datasource.resource : this._currentData.resource;
      apiObj.application = this._currentData.currentFormFields.datasource.application != undefined ? this._currentData.currentFormFields.datasource.application : this.appService.getApplication();

      apiObj.key = this._currentData.currentFormFields.datasource.key != undefined ? this._currentData.currentFormFields.datasource.key : 'id';
      apiObj.query_id = this._currentData.currentFormFields.datasource.query_id != undefined ? this._currentData.currentFormFields.datasource.query_id : "GET_BY_ID";

      let data = {};
      try {
        data = JSON.parse(sessionStorage.getItem('currentData'));
      } catch (error) { }

      apiObj.args = this._currentData.currentFormFields.datasource.args != undefined ? this.baseService.buildDyanamicStr(this._currentData.currentFormFields.datasource.args, { data: data }) : 'dummy:dummy';
      // Filter Functionality Added
      apiObj.filter = this._currentData.currentFormFields.datasource.filter != undefined ? this.baseService.buildDyanamicStr(this._currentData.currentFormFields.datasource.filter, { data: data }) : 'dummy:dummy';

      apiObj.args = apiObj.key + ":" + (this.route.snapshot && this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl.includes("reimbursement_format") ? data['id'] : this._currentData.currentId) + ',' + apiObj.args;
      if (this._currentData != undefined && this._currentData.currentFormFields != undefined && this._currentData.currentFormFields.datasource != undefined && this._currentData.currentFormFields.datasource.filter != undefined && this._currentData.currentFormFields.datasource.filter) {
        // Added backward compatibility for apiObj.key - 'if we don't want to pass id in filter then we need to pass key as false in datasource or it'll take key as id in filter (as it was taking earlier)' 
        if (apiObj.key) {
          apiObj.filter = apiObj.key + ":" + this._currentData.currentId + ',' + apiObj.filter;
        }
      }
    }
    this.baseService.get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application, apiObj.filter != undefined && apiObj.filter ? apiObj.filter : "").subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          if (data.resource != undefined && data.resource.length > 0) {
            this._currentData.currentData = data.resource[0];
          } else {
            this._currentData.currentData = [];
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }
  saveData(event, callback = null) {
    this.loader.showSpinner();
    var relayId;
    if (this._currentData.currentAction == 'MODIFY') {
      event.result.id = this._currentData.currentData.id;
      if (event.result != undefined && event.result.id) {
        relayId = JSON.parse(JSON.stringify(event.result.id));
      }
    } else if (this._currentData.currentAction == 'ADD') {
      if (event.result != undefined && event.result.id) {
        relayId = JSON.parse(JSON.stringify(event.result.id));
      }
      delete event.result.id;
      delete event.result.g_creation_time;
    }
    var resource = '';
    var application = '';
    var action = '';
    if (this._currentData.currentFormFields.APIresource && this._currentData.currentFormFields.APIresource != undefined && this._currentData.currentFormFields.APIresource.datasource != undefined) {
      console.log("API Resource", this._currentData.currentFormFields.APIresource)
      resource = this._currentData.currentFormFields.APIresource.datasource['resource'];
      application = this._currentData.currentFormFields.APIresource.datasource['application'];
      if (this._currentData.currentFormFields.APIresource.datasource.action != undefined) {
        action = this._currentData.currentFormFields.APIresource.datasource.action;
      } else {
        action = this._currentData.currentAction;
      }
    } else {
      resource = this._currentData.resouceDef.resource;
      application = '';
      action = this._currentData.currentAction;
    }
    if (event && event.currentBtnVal && event.currentBtnVal.datasource != undefined && event.currentBtnVal.datasource.action != undefined) {
      action = event.currentBtnVal.datasource.action
    }
    event.result = { ...event.result, ...this._currentData.foreignKeyData };
    if (this._currentData.currentFormFields.append_object != undefined && this._currentData.currentFormFields.append_object) {
      event.result = { ...event.result, ...this._currentData.currentFormFields.append_object };
    }
    let projection_keys;
    if (this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.form != undefined && this._currentData.resouceDef.form.postProjectionKeys != undefined) {
      projection_keys = this._currentData.resouceDef.form.postProjectionKeys;
    }

    // (_resource, action, application ?, resource ?, bpmn_action ?, responseType ?, args ?, obj ?)

    //passing undefined to handle parameters for projections
    event.result['id']=this.view_details.id;
    if (this.view_details && this.view_details.bill_details) {
      event.result['bill_details'] = this.view_details.bill_details
    }
    if (this.view_details && this.view_details.total_discount_amount) {
      event.result['total_discount_amount'] = this.view_details.total_discount_amount
    }
    if (this.view_details && this.view_details.total_service_amount) {
      event.result['total_service_amount'] = this.view_details.total_service_amount
    }
    if (this.view_details && this.view_details.approved_amount_summary) {
      event.result['approved_amount_summary'] = this.view_details.approved_amount_summary
    }
    if (this.view_details && this.view_details.finance_approved_amount_summary) {
      event.result['finance_approved_amount_summary'] = this.view_details.finance_approved_amount_summary
    }
    if (this.view_details && this.view_details.net_amount_summary) {
      event.result['net_amount_summary'] = this.view_details.net_amount_summary
    }
    if (this.view_details && this.view_details.gst_amount) {
      event.result['gst_amount'] = this.view_details.gst_amount
    }
    if (this.view_details && this.view_details.recoverable_amount_summary) {
      event.result['recoverable_amount_summary'] = this.view_details.recoverable_amount_summary
    }
    if (this.view_details && this.view_details.amount_payable_summary) {
      event.result['amount_payable_summary'] = this.view_details.amount_payable_summary
    }
    if (this.view_details && this.view_details.admission_date_time) {
      event.result['admission_date_time'] = this.view_details.admission_date_time
    }
    if (this.view_details && this.view_details.discharge_date_time) {
      event.result['discharge_date_time'] = this.view_details.discharge_date_time
    }
    if (this.view_details && this.view_details.bill_date_time) {
      event.result['bill_date_time'] = this.view_details.bill_date_time
    }
    let ap_data;
    if(event.currentBtnVal.label == "button.final")
    {
    this.extra_form.form['APIresource'] =   {"resource": "referral_request_approval",
    "application": "insurance",
    "action": "Accept Bill Submitted"}
    ap_data = this.extra_form.form['APIresource'];
    }
    else if(event.currentBtnVal.label == "button.reject")
    {
    this.extra_form.form['APIresource'] =   { "resource": "referral_request_approval",
    "application": "insurance",
    "action": "Reject"}
    ap_data = this.extra_form.form['APIresource']
    }
    else
    if(this.extra_form && this.extra_form.form && this.extra_form.form.APIresource && this.extra_form.form.APIresource.datasource)
    ap_data=this.extra_form.form.APIresource.datasource;
    this.baseService.action(event.result, ap_data.action, ap_data.appliation ? ap_data.appliation : ap_data.application, ap_data.resource, undefined, undefined, undefined, { postProjectionKeys: projection_keys }).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (this._currentData.decorator != undefined && this._currentData.decorator) {
            this._currentData.decorator.afterSubmitReqError(event, data, this.formComponenet);
          }
          if (callback) {
            callback(false);
          }
        } else {
          if (this._currentData != undefined && this._currentData.currentFormFields != undefined && this._currentData.currentFormFields.APIresource != undefined && this._currentData.currentFormFields.APIresource.relay_call != undefined && this._currentData.currentFormFields.APIresource.relay_call) {
            this.relayCall(event, relayId, () => {
              this.afterSubmitActions(event, data);
            });
          }
          else {
            this.afterSubmitActions(event, data);
          }
        }
        this.loader.hideSpinner();
        if (callback != null) {
          data['resourceName'] = resource;
          callback(data);
        }
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback) {
          callback(false);
        }
      }
    )
  }
  ngOnDestroy() {
    // this.resetDublicasyHistory();
    this.communicationService.emitSidebar({ sidebar: true });
  }
}
